export const projectOptions = [
	{
		id: "opt1",
		name: "done",
		link: "/projects",
		label: "Projets terminés",
	},
	// {
	// 	id: "opt2",
	// 	name: "inProgress",
	// 	link: "/projects-in-progress",
	// 	label: "Projet en cours",
	// },
	{
		id: "opt3",
		name: "challenge",
		link: "/challenges",
		label: "Mes défis",
	},
];
